import * as actions from "../actions/actionTypes"
import { users } from "./initialState"

const userReducer = (state = users, action) => {
    switch (action.type) {
        case actions.USER_LIST_REQUEST:
        case actions.USER_ADD_REQUEST:
        case actions.USER_GET_REQUEST:
            return {
                ...state,
                requesting: true,
                error: false,
                errorBody: null,
                record: null,
            }
        case actions.USER_UPDATE_REQUEST:
            return {
                ...state,
                requesting: true,
                error: false,
                errorBody: null,
            }
        case actions.USER_LIST_SUCCESS:
            return {
                ...state,
                requesting: false,
                list: action.payload,
            }
        case actions.USER_ADD_SUCCESS:
        case actions.USER_UPDATE_SUCCESS:
            return {
                ...state,
                requesting: false,
            }
        case actions.USER_GET_SUCCESS:
            return {
                ...state,
                requesting: false,
                record: action.payload,
            }
        case actions.USER_ADD_ERROR:
        case actions.USER_GET_ERROR:
        case actions.USER_LIST_ERROR:
        case actions.USER_UPDATE_ERROR:
            return {
                ...state,
                requesting: false,
                error: true,
                errorBody: action.payload,
            }
        default:
            return state
    }
}

export default userReducer;